const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://fcy89ljg17.execute-api.us-west-2.amazonaws.com/prod',
    COMPANY_API_URL: 'https://1qrcp03hk8.execute-api.us-west-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'taxonomy-company-1.13.4',
    HOSTNAME: 'https://company.barrick.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.barrick.forwoodsafety.com',
    WEBSOCKET: 'wss://i7rfamperj.execute-api.us-west-2.amazonaws.com/prod'
  },
};

export default config;